import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const NavigationPin_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 5C10.9633 5 7 8.79482 7 13.3333C7 15.572 7.95355 17.6144 9.52742 19.1227L9.57733 19.1705L15.6349 26.838C15.7049 26.9267 15.8364 27 16 27C16.1636 27 16.2951 26.9267 16.3651 26.838L22.4226 19.1706L22.4725 19.1227C24.0464 17.6144 25 15.572 25 13.3333C25 8.79482 21.0367 5 16 5ZM5 13.3333C5 7.56253 9.99097 3 16 3C22.009 3 27 7.56253 27 13.3333C27 16.1352 25.813 18.6669 23.9073 20.5175L17.9345 28.0779C17.4659 28.6709 16.7439 29 16 29C15.2561 29 14.534 28.6709 14.0655 28.0779L8.09264 20.5175C6.18695 18.6668 5 16.1351 5 13.3333ZM16 9C13.5147 9 11.5 11.0147 11.5 13.5C11.5 15.9853 13.5147 18 16 18C18.4853 18 20.5 15.9853 20.5 13.5C20.5 11.0147 18.4853 9 16 9ZM9.5 13.5C9.5 9.91015 12.4101 7 16 7C19.5899 7 22.5 9.91015 22.5 13.5C22.5 17.0899 19.5899 20 16 20C12.4101 20 9.5 17.0899 9.5 13.5Z"
            />
        </SvgStyled>
    );
};

export default NavigationPin_lg;
